import { render, staticRenderFns } from "./AddContractor.vue?vue&type=template&id=50632536&scoped=true"
import script from "./AddContractor.vue?vue&type=script&lang=js"
export * from "./AddContractor.vue?vue&type=script&lang=js"
import style0 from "./AddContractor.vue?vue&type=style&index=0&id=50632536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50632536",
  null
  
)

export default component.exports